var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50003 15.9978C2.22387 15.9978 2 15.7739 2 15.4978V5.49722C2 5.22106 2.22387 4.99719 2.50003 4.99719H6.00022C6.27638 4.99719 6.50025 5.22106 6.50025 5.49722C6.50025 5.77338 6.27638 5.99725 6.00022 5.99725H3.00006V14.9977H13.0006V5.99725H10.0004C9.72429 5.99725 9.50042 5.77338 9.50042 5.49722C9.50042 5.22106 9.72429 4.99719 10.0004 4.99719H13.5006C13.7768 4.99719 14.0007 5.22106 14.0007 5.49722V15.4978C14.0007 15.7739 13.7768 15.9978 13.5006 15.9978H2.50003ZM8.50036 1.83109V11.4963C8.50036 11.7732 8.27842 11.9976 8.00033 11.9976C7.72418 11.9976 7.50031 11.7778 7.50031 11.4963V1.83109L6.12188 3.36168C5.93714 3.56682 5.62097 3.58345 5.41571 3.39883C5.21044 3.21421 5.1938 2.89825 5.37854 2.69312L7.66828 0.150607C7.85186 -0.0532396 8.149 -0.0530245 8.33239 0.150607L10.6221 2.69312C10.8069 2.89825 10.7902 3.21421 10.585 3.39883C10.3797 3.58345 10.0635 3.56682 9.87879 3.36168L8.50036 1.83109Z",
    fill: "#fa9c14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOrange);
export default __webpack_public_path__ + "static/media/share_orange.53e08bef483cc47ff3fcdcf64e25d8bb.svg";
export { ForwardRef as ReactComponent };